




































import Vue from 'vue'
import './ChromaKeyModal.scss'
import Modal from '@/components/Modal'
import ChromaKeySliders from '@/components/ChromaKeySliders'
import VideoPlayer from '@/components/VideoPlayer'
import helpers from '../../helpers'
import { Stream, StreamsManager } from '@/types/streams'
import { UserProfile } from '@/types/users'

export default Vue.extend({
  name: 'ChromaKeyModal',
  props: {
    user: {
      type: Object as () => UserProfile
    },
    streamsManager: {
      type: Object as () => StreamsManager | undefined
    },
    casterStreamKey: {
      type: String
    }
  },
  data: () => ({
    randStr: null as string|null,
    pickingMode: false,
    chromakey: {
      enabled: false,
      screen: '#20AA20',
      weight: 10,
      balance: 20,
      clipblack: 30,
      clipwhite: 80
    }
  }),
  mounted (): void {
    if (this.user && this.user.chromakey) {
      this.chromakey = JSON.parse(JSON.stringify(this.user.chromakey))
    }
  },
  created (): void {
    this.randStr = 'v' + helpers.makeId()
  },
  watch: {
    user (): void {
      if (this.user && this.user.chromakey) {
        this.chromakey = JSON.parse(JSON.stringify(this.user.chromakey))
      }
    }
  },
  computed: {
    streamSrc (): Stream|null {
      if (this.streamsManager === undefined) return null
      const stream = this.streamsManager[this.casterStreamKey + '_lowrate'] ?? null
      return stream
    }
  },
  methods: {
    saveAndHideModal (): void {
      this.$store.direct.dispatch.user.updateOtherProfile({ id: this.user.id, chromakey: this.chromakey })
      this.hideModal()
    },
    hideModal (): void {
      this.pickingMode = false
      this.$emit('hideModal')
    },
    colorPicked (color: string): void {
      this.pickingMode = false 
      // @ts-ignore
      this.$refs.chromaKeySliders.colorPicked(color) 
    },
    setPickingMode (enabled: boolean): void {
      this.pickingMode = enabled
    }
  },
  components: {
    Modal,
    ChromaKeySliders,
    VideoPlayer
  }
})
